// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { LayoutState, LeftSidebarState } from '../../../../common/types.tsx';

export const setLeftSidebarState =
	(newState: Partial<LeftSidebarState>): Action<LayoutState> =>
	({ getState, setState }) => {
		const { content } = getState();
		setState({
			content: { ...content, leftSidebar: { ...content.leftSidebar, ...newState } },
		});
	};
